import { colors } from "../../../../styles/colors";
import type {
  BySource,
  Ratings,
  SourceData,
} from "../../../../types/dashboard";

export const getSubscriptionData = (
  bySource?: BySource | { [key: string]: SourceData } | null
) => {
  // Only use by_source data, no fallback
  if (!bySource) {
    return [];
  }

  const sourceMapping = [
    { key: "recommendation", label: "קידום ממומן", color: colors.yellow },
    { key: "search", label: "חיפוש חופשי", color: colors.red },
    { key: "suggestion", label: "קידום", color: colors.orange },
    { key: "direct", label: "טריגר ישיר", color: colors.teal },
    { key: "categories", label: "קטגוריות", color: colors.purple },
  ];

  // First pass: collect all data and calculate total subscriptions
  const dataWithSubscriptions = sourceMapping
    .map(({ key, label, color }) => {
      const data = bySource[key as keyof typeof bySource];
      if (!data) return null;

      return {
        source: label,
        views: data.views || 0,
        addedUsers: data.joins || 0,
        conversionRate: data.conversion_rate || 0,
        color,
      };
    })
    .filter((item): item is NonNullable<typeof item> => item !== null);

  // Calculate total subscriptions
  const totalSubscriptions = dataWithSubscriptions.reduce(
    (sum, item) => sum + item.addedUsers,
    0
  );

  // Second pass: calculate subscription percentages
  const result = dataWithSubscriptions.map((item) => ({
    ...item,
    subscriptionPercentage:
      totalSubscriptions > 0 ? (item.addedUsers / totalSubscriptions) * 100 : 0,
  }));

  return result;
};

export const getRatingData = (ratings?: Ratings | null) => {
  // Only use ratings data, no fallback
  const rating = ratings?.score || 0;
  const ratingCount = ratings?.count || 0;

  return {
    rating,
    ratingCount,
  };
};
